import { Helpers } from '../../helpers';
import { IUserRankingCategory } from '../../interfaces/iuser-ranking-category';
import { Well } from '../well';

export class UserRankingCategoryBase {
  UserRankingCategoryId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Wells_UserRankingCategory?: Array<Well> | null;

  constructor(item?: IUserRankingCategory) {
    if (item) {

      this.UserRankingCategoryId = item.UserRankingCategoryId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Wells_UserRankingCategory = Helpers.createClassArray(Well, item.Wells_UserRankingCategory);
    }
  }
}